import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "O que é contemplação?",
    a: "É o momento em que o grupo libera a sua carta de crédito e você pode usar o valor para comprar seu imóvel ou veículo. A contemplação acontece conforme as regras do grupo — por sorteio ou por lance — e nenhuma consultora séria pode garantir data.",
  },
  {
    q: "Como funciona o lance?",
    a: "O lance é uma antecipação de contribuições que aumenta as suas chances de ser contemplado em assembleia. Ele pode ser feito com recursos próprios e, no consórcio de imóvel, o FGTS pode ser aceito como lance, conforme as regras vigentes.",
  },
  {
    q: "O que é a taxa de administração?",
    a: "É a remuneração da administradora pelo serviço, diluída nas suas mensalidades. É o que sustenta o funcionamento do grupo — e é justamente por isso que o consórcio não tem juros de financiamento.",
  },
  {
    q: "O que é o fundo de reserva?",
    a: "É uma garantia coletiva que protege o grupo em imprevistos e assegura o funcionamento do plano. Ele também compõe as suas mensalidades e fica claro na simulação oficial.",
  },
  {
    q: "O que é a carta de crédito?",
    a: "É o valor do seu plano, liberado na contemplação, para você comprar à vista. Compra à vista dá poder de negociação: desconto à vista, mais força para fechar um bom negócio.",
  },
  {
    q: "Posso usar o FGTS no consórcio de imóvel?",
    a: "Sim, o FGTS pode ser utilizado no consórcio de imóveis — por exemplo, como lance — conforme as regras vigentes do programa. Como essas regras mudam periodicamente, a Isabela confirma as condições atuais antes de você decidir.",
  },
  {
    q: "O que acontece se eu desistir do consórcio?",
    a: "Você pode solicitar o cancelamento quando quiser. A devolução dos valores contribuídos segue as regras do grupo e do contrato — em geral ocorre após o prazo previsto no contrato, com eventuais deduções previstas. A Isabela explica todos os detalhes antes de você assinar qualquer coisa.",
  },
  {
    q: "Quanto custa participar?",
    a: "O consórcio tem taxa de administração e fundo de reserva, que ficam completamente claros na sua simulação oficial. Aqui não existe promessa de 'sem custo': transparência total desde o primeiro contato.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="scroll-mt-24 bg-slate-50 py-24 md:py-32" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-6 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-4"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-600">Dúvidas frequentes</p>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Perguntas honestas, respostas claras
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Sem jargão e sem letra miúda escondida. Se ficar qualquer dúvida, o chat ou o WhatsApp
            estão a um clique.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
          className="lg:col-span-8"
        >
          <Accordion type="single" collapsible className="rounded-3xl border border-slate-200 bg-white px-6">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200 last:border-0">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-5 text-left font-display text-base font-bold text-slate-900 hover:no-underline hover:text-brand-600"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
